export default __webpack_public_path__ + "static/media/logo.a18ccc33.png";